// extracted by mini-css-extract-plugin
export default {"anchor":"OurTeam_anchor__es+5J"};